module.exports = __webpack_public_path__ + "static/media/vr_drive.53af14b2.jpg";